import { useTranslation } from 'react-i18next'
import { EditSolidIcon } from '@dhl-ui/icons'
import { Body1, Card, Divider, H6, IconButton, List, ListItem, ListItemText } from '@dhl-ui/components'
import type { RoleCategory } from '~/modules/adminusers/model'

type Props = {
  userRoleCategories: RoleCategory[]
  onEditClick: () => void
}

export const RolesCard = ({ userRoleCategories, onEditClick }: Props) => {
  const { t } = useTranslation()

  if (!userRoleCategories) return null

  return (
    <Card>
      <Card.Header
        title={t('admin.adminUsersPage.rolesPage.titleText')}
        endNode={
          <IconButton aria-label="edit admin roles" onClick={onEditClick}>
            <EditSolidIcon data-testid="edit-admin-roles" />
          </IconButton>
        }
      />
      <Card.Content>
        <List>
          {userRoleCategories.map((userRoleCategory) => (
            <ListItem hasDivider={false} key={userRoleCategory.name}>
              <ListItemText key={userRoleCategory.name}>
                <Body1 sx={{ mb: 1 }}>{userRoleCategory.name}</Body1>
                {userRoleCategory.roles.map((role) => (
                  <List key={role} gap={2} sx={{ ml: 2 }}>
                    <ListItem hasDivider={false}>
                      <H6 sx={{ mb: 1 }}>{t(`admin.adminUsersPage.rolesPage.${role}`)}</H6>
                    </ListItem>
                  </List>
                ))}
                <Divider sx={{ mt: 2 }} variant="middle" />
              </ListItemText>
            </ListItem>
          ))}
        </List>
      </Card.Content>
    </Card>
  )
}
